import React from 'react'
import { storiesOf } from '@storybook/react'

import JerseyFront from 'components/JerseyFront'

storiesOf('Jersey/JerseyFront', module)
  .addDecorator((story) => (
    <>
      <div style={{ padding: 32, backgroundColor: '#DDD', width: 128 }}>{story()}</div>
    </>
  ))
  .add('default', () => (
    <JerseyFront />
  ))
